// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var wangStoreRouter = {
  path: '/wangStore',
  component: Layout,
  redirect: '/wangStore/pushProduct',
  name: 'WangStore',
  alwaysShow: true,
  meta: {
    title: '旺店通',
    icon: 'clipboard',
    roles: ['admin']
  },
  children: [{
    path: 'pushProduct',
    component: function component() {
      return import('@/views/wangStore/pushProduct');
    },
    name: 'WangStorePushProduct',
    meta: {
      title: '推送商品'
    }
  }, {
    path: 'manualPush',
    component: function component() {
      return import('@/views/wangStore/manualPush');
    },
    name: 'WangStoreManualPush',
    meta: {
      title: '手动推送'
    }
  }, {
    path: 'orderRecord',
    component: function component() {
      return import('@/views/wangStore/pushRecord');
    },
    name: 'WangStoreOrderRecord',
    meta: {
      title: '订单推送记录'
    }
  }]
};
export default wangStoreRouter;